import { Link } from "@tanstack/react-router";
import type { ComponentProps } from "react";

import { LabelApp } from "../LabelApp/LabelApp";

type Props = {
  appIntegrationId: string;
} & ComponentProps<typeof LabelApp>;

/**
 * アプリのアバターを表示するコンポーネントです。
 * srcが見つからない場合、アプリのアイコンがフォールバックとして表示されます。
 *
 * FIXME: featureでは依存順序観点でLinkのようなroutes以下に依存するコンポーネントの利用を避けたい
 * 一方で、そのroutesの情報を注入するhooksの置き場所が難しく、現時点ではこの形式に...
 * @see https://github.com/standandforce/dresscode-frontend/pull/1315#discussion_r2121084637
 */
export function AvatarAppIntegrationLink(props: Props) {
  return (
    <Link to="/app-integrations/$id" params={{ id: props.appIntegrationId }}>
      <LabelApp {...props} hoverScale />
    </Link>
  );
}
